<template>
  <v-content class="login fill-height background">
    <v-container
      fill-height
      class="flex-column"
    >
      <v-row
        fill-height
        no-gutters
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          lg="6"
          v-show="!passwordSend"
        >
          <v-card class="pa-7">
            <h2 class="headline font-weight-regular primary--text pb-1">
              Recuperar senha
            </h2>
            <p class="font-weight-light">
              Informe o seu e-mail cadastrado para recuperar sua senha
            </p>
            <v-form
              ref="recoverForm"
              v-model="form"
              lazy-validation
            >
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    v-model="recEmail"
                    :rules="[rules.emailRules]"
                    validate-on-blur
                    label="Insira seu email"
                    required
                    type="email"
                    @keyup.enter.native="sendRecoverEmail"
                  />
                  <div
                    v-if="error"
                    class="red white--text pa-2 my-2"
                    role="alert"
                  >
                    {{ error.message }}
                  </div>
                </v-col>
              </v-row>
              <div class="pt-0 text-right">
                <v-btn
                  text
                  color="accent"
                  :block="$vuetify.breakpoint.smAndDown"
                  :to="{name: 'Login'}"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  rounded
                  color="primary"
                  :block="$vuetify.breakpoint.smAndDown"
                  @click="sendRecoverEmail"
                >
                  Enviar
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          lg="6"
          v-show="passwordSend"
        >
          <v-card class="pa-5">
            <p class="black--text font-weight-light">
              Um e-mail com o link para reiniciar sua senha foi enviado para você
            </p>
            <div class="py-3">
              Não recebeu?
              <a
                class="font-weight-bold ml-3 primary--text"
                @click="sendRecoverEmailAgain"
              >
                Reenviar e-mail
              </a>
            </div>
            <div class="py-3 text-right">
              <v-btn
                text
                color="accent"
                :block="$vuetify.breakpoint.smAndDown"
                :to="{name: 'Login'}"
              >
                Voltar ao login
              </v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col
          class="align-center text-center white--text"
          cols="12"
          lg="6"
          order="2"
        >
          <h1 class="headline font-weight-regular pb-5">
            Bem-vindo ao Centro <br>de Memória
          </h1>
          <p
            style="max-width: 400px"
            class="mx-auto"
          >
            A Wilson Sons acredita que os registros da sua trajetória
            são parte integrante do seu legado para a sociedade. Por
            isso, em 2006, implantou o Centro de Memória, que disponibiliza
            o seu acervo on-line para consultas e atende pesquisadores
            do Brasil e do Exterior.
          </p>
          <router-link :to="{name: 'Dashboard'}">
            <img src="@/assets/logo-small.png">
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { mapActions } from 'vuex';
import formRules from '@/mixins/form-rules';

export default {
  name: 'ForgotPassword',
  props: {
    sessionError: {
      type: Error,
      default: null,
    },
  },
  mixins: [formRules],
  data() {
    return {
      form: true,
      recEmail: null,
      recoverError: null,
      recoverSuccess: null,
      recoverEmail: null,
      passwordSend: false,
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+/.test(v) || 'E-mail precisa ser válido',
      ],
    };
  },
  watch: {
    sessionError: {
      handler(err) {
        this.error = err;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('auth', ['rememberPassword']),
    sendRecoverEmail() {
      this.recoverError = null;
      if (this.$refs.recoverForm.validate()) {
        this.rememberPassword(this.recEmail)
          .then(() => {
            this.passwordSend = true;
          })
          .catch((err) => {
            this.$toasted.error(err.message || err);
          });
      } else {
        this.recoverError = {
          message: 'Por favor, cheque o e-mail inserido e tente novamente',
        };
        this.recEmail = null;
      }
    },
    sendRecoverEmailAgain() {
      this.sendRecoverEmail();
      this.$toasted.success('Email reenviado.');
    },
  },
};
</script>
